import { GeneralModal } from './GeneralModal';
import { ModalButton } from './ModalButton';
import { Typography, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#84d8c5',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#84d8c5',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#84d8c5',
    },
  },
});

export const SingleMessageModal = (props) => {
  return (
    <GeneralModal open={props.open} onClose={props.onClose}>
      <Typography sx={{ mb: 1, fontWeight: 600 }} variant="h5">
        Clock In Message
      </Typography>
      <CssTextField
        fullWidth
        disabled
        value={`Recipient: ${props.recipient}`}
        margin="normal"
      />
      <CssTextField fullWidth required margin="normal" label="Subject" />
      <CssTextField
        fullWidth
        multiline
        rows={5}
        required
        margin="normal"
        label="Message"
      />
      <ModalButton
        primaryBtnName="Send"
        secondaryBtnName="Cancel"
        primaryClickHandler={props.primaryClickHandler}
        secondaryClickHandler={props.secondaryClickHandler}
      />
    </GeneralModal>
  );
};
